import { Directive, Input, ElementRef, OnInit } from '@angular/core';
import { TableConfigType } from '../table-config/table-config.directive';

@Directive({
    selector: '[appDetailRow]',
    standalone: true
})
export class DetailRowDirective implements OnInit {

  readonly CSS_DETAIL_ROW = 'detail-row';

  @Input() appDetailRow = TableConfigType.DEFAULT;

  constructor(private ref: ElementRef) { }

  ngOnInit(): void {
    if (this.appDetailRow === TableConfigType.SELECT) {
      const row = (this.ref.nativeElement as HTMLElement);
      row.classList.add(this.CSS_DETAIL_ROW);
      // this td is created on table with select (no content, just for html)
      const n = document.createElement("td");
      n.classList.add('fake-td');
      n.classList.add('mat-mdc-cell');
      n.classList.add('mdc-data-table__cell');
      row.prepend(n);
      n.nextElementSibling.setAttribute('colspan', (row.previousElementSibling.querySelectorAll('td').length - 1)+'');
    }
  }
}
